const mutations = {
  SET_UNREAD_MESSAGES( state, payload ) {
    const { statusTaskCount, taskMessagesCount, unreadedCount } = payload;
    state.unreadMessages = taskMessagesCount;
    state.unreadByStatuses = statusTaskCount;
    state.unreadMessagesTotal = unreadedCount;
  },
};

export default mutations;
